import validate from 'validate.js';
import IApplicationState from 'app/types/state';
import { getCurrentAdmin } from 'app/ducks/admins/selectors';

export const getLoading = (state: IApplicationState): any => state.loading;
export const getGlobalLoading = (state: IApplicationState): any => state.global;
export const appReady = (state: IApplicationState): boolean => {
  const userValidation = {
    id: {
      presence: true,
    },
  };

  const userErrors = validate(getCurrentAdmin(state), userValidation);
  const globalLoading = state.global.isLoading && !state.global.hasLoaded;

  // return !state.loading.isLoading && !globalLoading && !!(userErrors === undefined);
  return !globalLoading && !!(userErrors === undefined);
};
export default null;
